import type { Registration } from '@/types/registration.types';

export type InPersonBlockReason = 'no-settings' | 'registration-off';

// Keyed on `registration_on`, not `registration_settings.type` — `type` can be `none` on a registration-enabled event. Allowed with SSO. Mirrored in events-3.
export const inPersonAttendeeModeBlockReason = (
  registrationSettings: Registration | null | undefined,
  registrationOn: boolean | undefined
): InPersonBlockReason | null => {
  if (!registrationSettings) return 'no-settings';
  if (!registrationOn) return 'registration-off';
  return null;
};

export const canUseInPersonAttendeeMode = (
  registrationSettings: Registration | null | undefined,
  registrationOn: boolean | undefined
): boolean => inPersonAttendeeModeBlockReason(registrationSettings, registrationOn) === null;
